import { apiGet, getApiBaseUrl } from './api-client';

export type GuideViewResult = {
  counted: boolean;
  views: number;
};

export type RelatedGuideCard = {
  id: string;
  title: string;
  slug: string;
  categoryId: string;
  categoryName?: string | null;
  publishedAt?: string | null;
  updatedAt: string;
  featured: boolean;
  views: number;
  readingTime: number;
  excerpt: string;
};

const VISITOR_STORAGE_KEY = 'xat_guide_vid';

function getOrCreateVisitorId(): string {
  if (typeof window === 'undefined') return '';
  try {
    const existing = window.localStorage.getItem(VISITOR_STORAGE_KEY);
    if (existing && /^[0-9a-f-]{36}$/i.test(existing)) return existing;
    const id = crypto.randomUUID();
    window.localStorage.setItem(VISITOR_STORAGE_KEY, id);
    return id;
  } catch {
    return crypto.randomUUID();
  }
}

/** Contabiliza visualização no servidor (cookie + visitor id + anti-F5 24h). */
export async function recordGuideView(
  categoryId: string,
  slug: string
): Promise<GuideViewResult | null> {
  try {
    const visitorId = getOrCreateVisitorId();
    const url = `${getApiBaseUrl()}/guides/${encodeURIComponent(categoryId)}/${encodeURIComponent(slug)}/view`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...(visitorId ? { 'X-Visitor-Id': visitorId } : {}),
      },
      credentials: 'include',
      body: '{}',
    });

    if (!response.ok) return null;
    const payload = (await response.json()) as { data?: GuideViewResult };
    return payload.data ?? null;
  } catch {
    return null;
  }
}

export async function getRelatedGuides(
  categoryId: string,
  slug: string
): Promise<RelatedGuideCard[]> {
  try {
    const res = await apiGet<{ data: RelatedGuideCard[] }>(
      `/guides/${encodeURIComponent(categoryId)}/${encodeURIComponent(slug)}/related`
    );
    return res.data ?? [];
  } catch {
    return [];
  }
}
